// @flow
import React from "react";

import { withStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

const styles = {
  root: {
    display: "inline-block",
    width: "100%",
    height: "100px",
    textAlign: "center",
  },
};

const LoaderBig = (props: Object) => {
  const { classes, size } = props;
  return (
    <div className={props.className ? props.className : classes.root}>
      <CircularProgress size={size ? size : 50} />
    </div>
  );
};

export default withStyles(styles)(LoaderBig);
